import { RevenueChart } from "@bcc/components/analytics/revenue-chart";
import { SalesChart } from "@bcc/components/analytics/sales-chart";
import { TopProductsChart } from "@bcc/components/analytics/top-products-chart";
import { CommonHeader } from "@bcc/components/common-header";
import { Button } from "@bcc/components/ui/button";
import { Calendar, Download } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  setAnalyticsViewChartGridTestId,
  setAnalyticsViewExportReportButtonTestId,
  setAnalyticsViewLast30DaysButtonTestId,
  setAnalyticsViewTestId,
} from "./analytics-view.utils";

interface RevenueData {
  month: string;
  revenue: number;
}

export interface SalesData {
  month: string;
  orders: number;
}

interface TopProductData {
  product: string;
  sales: number;
}

interface AnalyticsViewProps {
  revenueData: RevenueData[];
  salesData: SalesData[];
  topProductsData: TopProductData[];
  testId?: string;
}

export function AnalyticsView({ revenueData, salesData, topProductsData, testId }: AnalyticsViewProps) {
  const { t } = useTranslation();
  return (
    <div data-testid={testId ?? setAnalyticsViewTestId("container")} className="space-y-6">
      <CommonHeader
        title={t("views.analytics.title")}
        description={t("views.analytics.description")}
        actions={
          <>
            <Button variant="outline" data-testid={setAnalyticsViewLast30DaysButtonTestId()}>
              <Calendar className="mr-2 h-4 w-4" />
              {t("views.analytics.last30Days")}
            </Button>
            <Button variant="outline" data-testid={setAnalyticsViewExportReportButtonTestId()}>
              <Download className="mr-2 h-4 w-4" />
              {t("views.analytics.exportReport")}
            </Button>
          </>
        }
      />
      <div className="grid gap-6 lg:grid-cols-2" data-testid={setAnalyticsViewChartGridTestId()}>
        <RevenueChart data={revenueData} />
        <SalesChart data={salesData} />
      </div>
      <TopProductsChart data={topProductsData} />
    </div>
  );
}
